<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <h1>Custom Notification #{{ notification.id }}</h1>
          </div>
          <div class="col-md-4 hidden-xs hidden-sm">
            <div class="booking-status">
              <div class="row">
                <p>
                  <span :class="percentageClass">{{ talentResponseRate }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">

      <div class="dashboard-block">
        <h2>Notification details</h2>

        <div class="form-item__row">
          <div class="form-item__field" :class="field.full ? 'form-item__field--full' : ''" :key="field.label"
               v-for="field in calculatedFields">
            <div class="input-group input-group-booking-detail">
              <span class="input-group-addon">{{ field.label }}</span>
              <div class="form-control" v-if="field.html" v-html="field.content"></div>
              <p v-else class="form-control">{{ field.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="responseNotification" class="dashboard-block">
        <h2>Response Options</h2>

        <div v-for="(button) in notification.responses" :key="button.id">
          <div class="form-item__row m-b-xl">
            <div class="form-item__field">
              <div class="input-group input-group-booking-detail">
                <span class="input-group-addon">Button Label</span>
                <p class="form-control">{{ button.label }}</p>
              </div>
            </div>
            <div class="form-item__field">
              <div class="input-group input-group-booking-detail">
                <span class="input-group-addon">Assigned Tags</span>
                <p class="form-control">{{ tagString(button.associated_tags) }}</p>
              </div>
            </div>
            <div v-if="button.users_responded && button.users_responded.length > 0" class="form-item__field form-item__field--full">
              <div class="input-group input-group-booking-detail">
                <span class="input-group-addon">Talent Responses</span>
                <div class="form-control">
                  <div class="row">
                    <div v-for="respondedUser in button.users_responded" :key="respondedUser.id" class="col-xs-12 col-sm-6 col-lg-4">
                      <system-custom-notification-user-list-item class="row-user-response" :responded="respondedUser"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="talentResponded" class="dashboard-block">
        <h2>Notification Opened By</h2>
        <div class="form-item__field form-item__field--full">
          <div class="input-group input-group-booking-detail">
            <div class="input-group input-group-booking-detail">
              <span class="input-group-addon">Talent Responses</span>
              <div class="form-control">
                <div class="row">
                  <div v-for="respondedUser in notification.responded_users" :key="respondedUser.id"
                       class="col-xs-12 col-sm-6 col-lg-4">
                    <system-one-signal-user-list-item class="row-user-response" :responded="respondedUser"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {forEach} from 'lodash'
import SystemCustomNotificationUserListItem from './SystemCustomNotificationUserListItem'

export default {
  components: {
    SystemCustomNotificationUserListItem
  },

  props: ['id'],

  computed: {
    ...mapState('notification', ['notification']),

    calculatedFields () {
      const array = [
        { label: 'Channels', content: this.notification.channels.join(', '), full: true },
        !this.notification.email_subject || this.notification.same_subject === true ? { label: 'Heading', content: this.notification.title, full: true } : null,
        !this.notification.email_content || this.notification.same_content === true ? { label: 'Message', content: this.notification.content, full: true, html: true } : null,
        this.notification.email_subject ? { label: 'Email Subject', content: this.notification.email_subject, full: true } : null,
        this.notification.email_content ? { label: 'Email Subject', content: this.notification.email_content, full: true, html: true } : null,
        { label: 'Message Type', content: this.messageType, full: false },
        this.notification.link_url ? {label: 'Link URL', content: this.notification.link_url, full: false} : null,
        this.notification.package ? {label: 'Shown Package', content: this.notification.package.name, full: false} : null,
        { label: 'Talent Notified', content: this.notification.sent_to, full: false },
        { label: 'Talent Interacted', content: this.notification.responded_users.length, full: false },
        { label: 'Time Sent', content: this.$options.filters.timeTimezone(this.notification.created_at, this.$user.timezone), full: false },
        { label: 'Date Sent', content: this.$options.filters.dateTimezone(this.notification.created_at, this.$user.timezone, this.$user.date_format_preference), full: false }
      ]
      return array.filter(item => item !== null)
    },

    messageType () {
      if (this.notification.link_url) {
        return 'Web Link Notification'
      } else if (this.notification.responses && this.notification.responses.length > 0) {
        return 'Response Notification'
      } else if (this.notification.package) {
        return 'Package Notification'
      } else {
        return 'Basic Notification'
      }
    },

    percentageClass () {
      switch (true) {
        case this.notification.response_percentage < 20:
          return 'status status-bad text-center'
        case this.notification.response_percentage < 70:
          return 'status status-info text-center'
        default:
          return 'status status-good text-center'
      }
    },

    responseNotification () {
      return (this.notification.responses && this.notification.responses.length > 0)
    },

    linkNotification () {
      let result = false
      forEach(this.notification.sent_to, function (value) {
        if (value.notification_details.read_at) {
          result = true
        }
      })
      return result
    },

    talentResponded () {
      return (this.notification.responded_users && this.notification.responded_users.length > 0)
    },

    talentResponseRate () {
      return `${this.notification.responded_users.length}/${this.notification.sent_to} Responded`
    }
  },

  created () {
    this.getCustomNotification({id: this.id})
  },

  methods: {
    ...mapActions('notification', ['getCustomNotification']),

    tagString (tags) {
      let tagString = ''
      tags.forEach((val, index) => {
        tagString += val.name + ' '
      })
      return tagString.length > 0 ? tagString : 'N/A'
    }
  }
}
</script>
<style scoped>
  .row-user-response {
    text-align: center;
    border: #0a0a0a 1px solid;
    padding: 3%;
    margin: 3%;
    overflow: hidden;
  }
</style>
